import moment from 'moment';
import normalizeUrlParameter from './normalizeUrlParameter';

const syncLimitDate = new Date(new Date().getTime()+(3600 * 24));
export default function normalizeMenu(menu, excludeDeleted = false, foodRecipes = null) {
  if(!menu) {
    return {};
  }
  const x = new Date();
  const differenceFuseauxEnHeures = Math.abs(x.getTimezoneOffset() / 60);
  const canOrderUntill = menu.canOrderUntil ? (differenceFuseauxEnHeures < 0 ? (typeof menu.canOrderUntil == 'object' ? menu.canOrderUntil : `${menu.canOrderUntil}`.replace('+00:00', '-0'+Math.abs(differenceFuseauxEnHeures)+':00')) : (typeof menu.canOrderUntil == 'object' ? menu.canOrderUntil : `${menu.canOrderUntil}`.replace('+00:00', '+0'+differenceFuseauxEnHeures+':00'))) : new Date();
  const canOrderSince = menu.canOrderSince ? (differenceFuseauxEnHeures < 0 ? (typeof menu.canOrderSince == 'object' ? menu.canOrderSince : `${menu.canOrderSince}`.replace('+00:00', '-0'+Math.abs(differenceFuseauxEnHeures)+':00')) : (typeof menu.canOrderSince == 'object' ? menu.canOrderSince : `${menu.canOrderSince}`.replace('+00:00', '+0'+differenceFuseauxEnHeures+':00'))) : null;
  
  const orderNotAlreadyOkFor = canOrderSince && moment(canOrderSince).toDate() > new Date();
  const forDateDate = moment(menu.forDate).toDate();

  return {
    ...menu,
    synced: forDateDate > syncLimitDate,
    menuDateForUrl: normalizeUrlParameter(menu.menuDate),
    forDate: forDateDate,
    forDateMonth: moment(menu.forDate).format('MMMM'),
    forDateYear: moment(menu.forDate).format('YYYY'),
    forDateDay: moment(menu.forDate).format('D'),
    mailIntro: menu.mailIntro || '',
    forSearch: menu.menuDate + ' ' + moment(menu.forDate).format('D MMMM YYYY'),
    canOrderUntil: moment(canOrderUntill).toDate(),
    canOrderSince: canOrderSince ? moment(canOrderSince).toDate() : null,
    mailCreatedSendDateString: menu.mailCreatedSendDate ? moment(menu.mailCreatedSendDate).calendar() : '',
    mailLastChanceSendDateString: menu.mailLastChanceSendDate ? moment(menu.mailLastChanceSendDate).calendar() : '',
    
    canOrder: (moment(canOrderUntill).toDate() > new Date()),
    userCanOrder: (moment(canOrderUntill).toDate() > new Date()),
    orderNotAlreadyOkFor: orderNotAlreadyOkFor,
    foodMenuItems: (menu.foodMenuItems || [])
      .filter(fmi => !fmi.deleted || !excludeDeleted)
      .sort((a, b) => (a.orderPosition > b.orderPosition) ? 1 : -1)
      .map(foodMenuItem => ({
        ...foodMenuItem,
        collapsed: true,
        foodMenuItemOptions: (foodMenuItem.foodMenuItemOptions)
          .filter(fmio => !fmio.deleted || !excludeDeleted)
          .sort((a, b) => (a.orderPosition > b.orderPosition) ? 1 : -1)
          .map(fmio => {
             let pricePerDishInCts = 0;
             if(fmio.foodMenuItemOptionIngredientPrices) {
              fmio.foodMenuItemOptionIngredientPrices.forEach((fmiop) => {
                let ingredientAmount = fmiop.unitPriceInCts * fmiop.unitQuantity;
                pricePerDishInCts += ingredientAmount;
              });
             }
             
             let foodRecipe = fmio.foodRecipe;
             if(fmio.foodRecipe && foodRecipes) {
              const recipe = foodRecipes.find((recipe) => recipe.id == fmio.foodRecipe.id);
              if(recipe) {
                foodRecipe = recipe;
              }
             }
             
             return {
              ...fmio,
              foodRecipe: foodRecipe,
              initialMaximumQuantity: fmio.maximumQuantity,
              initialRemainingQuantity: fmio.remainingQuantity,
              soldQuantity: (fmio.maximumQuantity - fmio.remainingQuantity),
              pricePerDishInCts: pricePerDishInCts,
              pricePerDish: pricePerDishInCts / 100,

              foodMenuItemOptionDiscounts: (fmio.foodMenuItemOptionDiscounts)
                .filter(fmiod => !fmiod.deleted || !excludeDeleted)
                .sort((a, b) => (a.quantity < b.quantity) ? 1 : -1)
                .map(fmiod => {
                  return {
                    ...fmiod,
                    price: fmiod.priceInCts / 100,
                  };
                }),
            };
          }),
      })),
    foodMenuTakeAways: (menu.foodMenuTakeAways || [])
      .filter(fmi => !fmi.deleted || !excludeDeleted)
      .sort((a, b) => (a.orderPosition > b.orderPosition) ? 1 : -1),
    foodMenuPackagings: (menu.foodMenuPackagings || [])
      .filter(fmi => !fmi.deleted || !excludeDeleted)
      .sort((a, b) => (a.orderPosition > b.orderPosition) ? 1 : -1),
    foodMenuMediaObjectMenu: (menu.foodMenuMediaObjectMenu ? {...menu.foodMenuMediaObjectMenu, absoluteUri: `${process.env.VUE_APP_APIREMOTEROOTURL}${menu.foodMenuMediaObjectMenu.contentUrl}`} : null ),
  };
}
